import * as colors from 'assets/theme/colors';
import {TableCell, TableRow, Theme} from '@material-ui/core';
import {createStyles, makeStyles, withStyles} from '@material-ui/core/styles';
import NextIcon from 'assets/img/pagination/chevron-next.png';
import BackIcon from 'assets/img/pagination/chevron-back.png';
import NextIconHover from 'assets/img/pagination/chevron-next-hover.png';
import BackIconHover from 'assets/img/pagination/chevron-back-hover.png';
import {Column, TableItem} from 'commons/models/components/EfeTableValues';

export const StyledTableRow = withStyles(() =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: '#E5F4FB',
            },
            height: 37,
            lineHeight: 37,
            fontSize: '14px',
            fontWeight: 'bold',
            fontFamily: "'Noto Sans', sans-serif",
        },
    })
)(TableRow);

export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            minWidth: 80,
            fontSize: 14,
            backgroundColor: theme.palette.common.white,
            fontFamily: "'Noto Sans', sans-serif",
            color: theme.palette.common.black,
        },
        body: {
            minWidth: 80,
            fontSize: 13,
            fontFamily: "'Noto Sans', sans-serif",
            borderBottom: 0,
            height: '37px',
        },
    })
)(TableCell);

export const StyledTableHeaderCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.common.white,
            fontSize: 14,
            fontFamily: "'Noto Sans', sans-serif",
            fontWeight: 'bold',
            color: theme.palette.common.black,
        },
        body: {
            fontSize: 14,
            fontFamily: "'Noto Sans', sans-serif",
            borderBottom: 0,
            height: '37px',
        },
    })
)(TableCell);

export const StyledTableCellWithoutSize = withStyles((theme: Theme) =>
    createStyles({
        head: {
            fontSize: 14,
            backgroundColor: theme.palette.common.white,
            fontFamily: "'Noto Sans', sans-serif",
            color: theme.palette.common.black,
        },
        body: {
            fontSize: 13,
            fontFamily: "'Noto Sans', sans-serif",
            borderBottom: 0,
            height: '37px',
        },
    })
)(TableCell);

export const useTableStyles = makeStyles({
    table: {},
    header: {
        height: 37,
        color: colors.neutrals.A10,
        backgroundColor: colors.primary.A00,
        fontFamily: 'Georgia, serif',
    },
    title: {
        lineHeight: '37px',
        textAlign: 'center',
        fontSize: 14,
        fontFamily: "'Noto Sans', sans-serif",
        fontWeight: 'bold',
    },
    container: {
        paddingLeft: 0,
        paddingRight: 0,
    },
});

export const usePaginationStyles = makeStyles({
    pagination: {
        minHeight: '52px',
    },
    number: {
        borderRadius: '50%',
        width: '36px',
        height: '36px',
        padding: 10,
        background: '#D9D9D6',
        fontSize: '15px !important',
        textAlign: 'center',
        display: 'inline-block',
        '&:hover': {
            background: `${colors.primary.A20} !important`,
            color: `${colors.neutrals.A10} !important`,
        },
    },
    currentPage: {
        background: `${colors.primary.A20} !important`,
        color: `${colors.neutrals.A10} !important`,
        '&:hover': {
            background: `${colors.primary.A20} !important`,
            color: `${colors.neutrals.A10} !important`,
        },
    },
    nextPage: {
        background: colors.neutrals.A10 + ` url(${NextIcon}) no-repeat 15px`,
        backgroundSize: '20px 30px',
        border: '1px solid #0061A0',
        color: colors.primary.A20,
        textAlign: 'left',
        paddingLeft: '3px',
        fontWeight: 'bold',
        '&:hover': {
            background: colors.primary.A20 + ` url(${NextIconHover}) no-repeat 15px`,
            backgroundSize: '20px 30px',
        },
    },
    backPage: {
        background: colors.neutrals.A10 + ` url(${BackIcon}) no-repeat 0px`,
        backgroundSize: '20px 30px',
        border: '1px solid #0061A0',
        color: colors.primary.A20,
        textAlign: 'right',
        paddingRight: '2px',
        fontWeight: 'bold',
        '&:hover': {
            background: colors.primary.A20 + ` url(${BackIconHover}) no-repeat 0px`,
            backgroundSize: '20px 30px',
        },
    },
});

export function createDatasource(columns: Array<Column>, datasource: any): Array<TableItem> {
    const originalData = Object.assign(datasource);
    const tempArray: Array<TableItem> = [];
    originalData.forEach((item: any) => {
        let key = '';
        columns.forEach((column) => {
            if (column.cellType === 'text' && column.cell(item)) {
                const text: string = column.cell(item);
                key = `${key}${text.toString().trim().toLowerCase()}`;
            }
        });
        tempArray.push({
            key: key,
            data: item,
        });
    });
    return tempArray;
}
